'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002elang$002e$002dString$002dIndex$002dOut$002dOf$002dBounds$002dException from "./java.lang.-String-Index-Out-Of-Bounds-Exception.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal) {
  this.s4 = 0;
  this.s4 = literal;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = $p;
$p.hr = (function(context, buf) {
  var c = this.s4;
  var str = ("" + $j_java$002elang$002e$002dObject.$cToS(c));
  buf.r = (buf.r + str);
  return true;
});
$p.gG = (function(context, text, position) {
  var length = $j_java$002elang$002e$002dObject.$dp_length__I(text);
  if ((position === length)) {
    return (~position);
  }
  if (((position < 0) || (position > length))) {
    throw new $j_java$002elang$002e$002dString$002dIndex$002dOut$002dOf$002dBounds$002dException.$c_jl_StringIndexOutOfBoundsException();
  }
  var ch = $j_java$002elang$002e$002dObject.$dp_charAt__I__C(text, position);
  if ((!context.O7(this.s4, ch))) {
    return (~position);
  }
  return ((1 + position) | 0);
});
$p.b = (function() {
  return ((this.s4 === 39) ? "''" : (("'" + $j_java$002elang$002e$002dObject.$cToS(this.s4)) + "'"));
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser", ({
  lv: 1,
  av: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser };
